export default function radianToDegree(radian: number) {
  return Math.round(radian * (180 / Math.PI));
}

